import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Dropdown from 'react-bootstrap/Dropdown';
import { useTranslation } from 'react-i18next';
import { Checkbox, Icon } from '@fikasio/react-ui-components';
import DropdownToggle from 'components/UI/DropdownToggle';
import TrashIcon from 'components/UI/TrashIcon';
import links, { linkKey } from 'utils/links';

const EntityRow = ({
  entity,
  isSelected,
  onDelete,
  onSelect,
}) => {
  const { t } = useTranslation();

  return (
    <tr
      className={classNames({
        selected: isSelected,
      })}
    >
      <td
        style={{
          textAlign: 'center',
        }}
      >
        <Checkbox
          isChecked={isSelected}
          onClick={() => onSelect(entity)}
        />
      </td>
      <td
        style={{
          cursor: 'pointer',
          paddingLeft: 8,
        }}
      >
        <Link
          style={{ textDecoration: 'none' }}
          to={links.entity(linkKey(entity))}
        >
          <div
            style={{
              color: '#000',
              height: '100%',
              width: '100%',
            }}
          >
            {entity.name}
          </div>
        </Link>
      </td>
      <td
        style={{
          textAlign: 'center',
          width: 35,
        }}
      >
        <Link
          style={{ textDecoration: 'none' }}
          to={links.itemUpsert(linkKey(entity), 'NEW')}
        >
          <Icon
            name="plus"
            size="1x"
            style={{
              cursor: 'pointer',
            }}
          />
        </Link>
      </td>
      <td
        style={{
          textAlign: 'center',
          width: 35,
        }}
      >
        <Dropdown
          style={{
            position: 'static',
          }}
        >
          <Dropdown.Toggle as={DropdownToggle} />
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => onDelete(entity)}
            >
              <TrashIcon
                style={{
                  color: 'red',
                  marginRight: 10,
                  width: 25,
                }}
              />
              {t('delete')}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </td>
    </tr>
  );
};

export default EntityRow;
